/* Copyright (c) 2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { Button, ModalConfirm } from "@nordcloud/gnui";
import { APPlan } from "~/models";
import { generateActionConfirmText } from "~/tools";

type Props = {
  plan: APPlan;
  idx: number;
  removeCallback: (idx: number) => void;
};

function APPlanRemove({ plan, idx, removeCallback }: Props) {
  const [isOpen, setIsOpen] = React.useState(false);

  const removeConfig = React.useCallback(async () => {
    try {
      await removeCallback(idx);
    } finally {
      setIsOpen(false);
    }
  }, [removeCallback, idx]);

  return (
    <>
      <Button
        icon="trash"
        size="sm"
        severity="low"
        onClick={() => setIsOpen(true)}
      >
        Remove
      </Button>

      <ModalConfirm
        onClose={() => setIsOpen(false)}
        isOpen={isOpen}
        confirm={removeConfig}
        actionLabel="Remove"
        contentLabel="Remove AutoPatcher plan"
      >
        {generateActionConfirmText(`AutoPatcher plan ${plan.plan}`)("remove")()}{" "}
        <br />
      </ModalConfirm>
    </>
  );
}

export { APPlanRemove };
